import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context'
import { oidcProviderProps } from './auth/oidcConfig'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <OidcAuthProvider {...oidcProviderProps}>
      <App />
    </OidcAuthProvider>
  </StrictMode>,
)
